import { Map } from 'immutable';

import { UPDATE_VIEWSTATE, SET_VIEWSTATE, SELECT_PACKAGE } from './actions';

export const VIEW_STATES_KEY = 'viewStates';

export function viewStatesReducer(state = Map(), action) {
    switch (action.type) {
        case UPDATE_VIEWSTATE:
            return state.update(action.viewId, Map(), viewState => viewState.merge(action.update));

        case SET_VIEWSTATE:
            return state.set(action.viewId, action.viewState);

        case SELECT_PACKAGE:
            const pkgPath = [action.viewId, 'selectedPackages', action.packageId];
            return state.setIn(pkgPath, action.selected);
    }
    return state;
}
